import {Axios} from '../plugins/axios.js';


const state = {
}

const getters = {

}

const mutations =  {
}

const actions = {
  getTableData ({ commit, state }, payload) {
    const data = payload.data;

      const getData = () => {
        let city_id       = data.city_id;
        let province_id   = data.province_id;
        let page          = data.page;
        let url           = '';

        if (city_id == -1) {
          data.city_id = '';
        }

        if (province_id == -1) {
          data.province_id = '';
        }

        page += -1
        data.page = page;

        for (let content in data) {
          url+=`&${content}=${data[content]}`
        }


        return new Axios()
        .get(`biav/v1/admin/match?${url}`)
        .then(response => {
          return response;
        })
        .catch(()=>{
          return 'error';
        })
      }


      return Promise.all([getData()])
      .then(res => {
        const setData = {
          tableData             : res[0],
        }

        return setData
      })



  },

  getProvinceAndCity({ commit, state }, payload) {
        return new Axios()
        .get(`location/v1/province?include_city=1`)
        .then(response => {
          return response;
        })
        .catch(()=>{
          return 'error';
        })
  },


  entryAndEdit ({ commit, state }, payload) {
     const data             = payload.data;
     const formData         = new FormData();


     for (let key in data) {
       formData.append(key,data[key])
     }


     // request send new data //
     if (typeof(data.id) == 'undefined') {
         return new Axios()
         .post(`biav/v1/admin/match/store`,formData)
         .then(response => {
           return response;
         })
         .catch(()=>{
           return 'error';
         })
     }
     else {
       // edit data //
       return new Axios()
       .post(`biav/v1/admin/match/update`,formData)
       .then(response => {
         return response;
       })
       .catch(()=>{
         return 'error';
       })
     }

  },

  tabScorersAndKnockoutAndGroup ({ commit, state }, payload) {
    const data = payload.data;
    let url    = '';

    for (let content in data) {
      url+=`&${content}=${data[content]}`
    }

    return new Axios()
    .get(`biav/v1/admin/cup_item?${url}`)
    .then(response => {
      return response;
    })
    .catch(()=>{
      return 'error';
    })

  }











}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
